module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.title))]), _c('br'), _vm._v("\n    " + _vm._s(_vm.name) + "\n    "), _c('small', [_vm._v(_vm._s(_vm.address))])]), _vm._v(" "), (_vm.haveLocation) ? _c('button', {
    staticClass: "btn btn-xs btn-info m-b-md",
    attrs: {
      "data-toggle": "modal",
      "data-target": ".modal-location-details"
    },
    on: {
      "click": _vm.setLocation
    }
  }, [_vm._v("\n    View Details\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-6d98f2a6"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/LocationDetail.vue
// module id = 1033
// module chunks = 0